/**
 * Directive disable_all.js
 *
 * @namespace disable_all
 * @date 04/09/19
 * @author jasper.kerkhof
 * @copyright UniWeb bvba 2019
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/directives/disable_all.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
    inserted: function(el, binding){
        disableAllChildren(el, binding);
    },
    componentUpdated: function(el, binding){
        disableAllChildren(el, binding);
    }
};

function disableAllChildren(el, binding){
    if (!binding.expression || binding.value){
        disableAll(el);
    }
}

export function disableAll(el){
    if (el._vueDisabled){
        el._vueDisabled.forEach((elChild) => {
            elChild.disabled = false;
            elChild.style.visibility = 'visible';
            elChild.classList.remove('v-radio--is-disabled')
            elChild.classList.remove('v-slider--disabled')

            const parent = elChild.closest('.v-input');

            if (parent){
                setTimeout(() => {
                    parent.style.visibility = 'visible';
                    parent.classList.remove('v-input--is-disabled')
                })
            }
        });
    }

    el._vueDisabled = [];

    Array.from(el.querySelectorAll('.v-input:not(.ignoredisableall) input:enabled, textarea:not(.ignoredisableall):enabled')).forEach((child) => {
        child.disabled = 'disabled';
        el._vueDisabled.push(child);

        const parent = child.closest('.v-input');

        if (parent){
            setTimeout(() => {
                if (parent.classList.contains('hideondisableall')){
                    parent.style.visibility = 'hidden';
                }
                parent.classList.add('v-input--is-disabled')
            })
        }
    });

    Array.from(el.querySelectorAll('button:not(.ignoredisableall):enabled')).forEach((child) => {
        child.disabled = 'disabled';
        child.classList.add('v-btn--disabled');

        if (child.classList.contains('hideondisableall')){
            child.style.visibility = 'hidden';
        }

        el._vueDisabled.push(child);
    });

    Array.from(el.querySelectorAll('.v-radio:not(.ignoredisableall)')).forEach((child) => {
        child.disabled = 'disabled';
        child.classList.add('v-radio--is-disabled')

        if (child.classList.contains('hideondisableall')){
            child.style.visibility = 'hidden';
        }

        el._vueDisabled.push(child);
    });

    Array.from(el.querySelectorAll('.v-slider:not(.ignoredisableall)')).forEach((child) => {
        child.disabled = 'disabled';
        child.classList.add('v-slider--disabled')

        if (child.classList.contains('hideondisableall')){
            child.style.visibility = 'hidden';
        }

        el._vueDisabled.push(child);
    });
}